import React, { Component } from 'react';
import {Alert, Badge, Card, CardHeader, CardBody, Col, Container, Row, Nav, NavItem, NavLink, TabPane, TabContent, Table} from 'reactstrap';
import {withRouter, Link} from "react-router-dom";

const moment = require("moment")

class TabAnag extends Component {

    render() {

        const client = this.props.client;

        return (
            <React.Fragment>
                <Row>
                    <Col xxl={12}>
                        <Card>
                            <CardHeader>
                                <h5 className="card-title mb-5 d-md-none">Posizione</h5>
                            </CardHeader>
                            <CardBody>
                                <div className="table-responsive" style={{padding: 10}}>
                                    <Table className="table-borderless mb-0">
                                        <tbody>
                                            <tr>
                                                <th className="ps-0" scope="row">Nome e Cognome:</th>
                                                <td className="text-muted">{client.firstname} {client.lastname}</td>
                                            </tr>
                                            <tr>
                                                <th className="ps-0" scope="row">Email:</th>
                                                <td className="text-muted"><a href={"mailto:" + client.email}>{client.email}</a></td>
                                            </tr>
                                            <tr>
                                                <th className="ps-0" scope="row">Telefono:</th>
                                                <td className="text-muted"><a href={"tel:" + client.cell}>{client.cell}</a></td>
                                            </tr>
                                            <tr>
                                                <th className="ps-0" scope="row">Data di Nascita:</th>
                                                <td className="text-muted">{(client.birth_date) ? moment(client.birth_date, "YYYY-MM-DD").format("DD/MM/YYYY") : "N/D"}</td>
                                            </tr>
                                            <tr>
                                                <th className="ps-0" scope="row">Luogo di Nascita:</th>
                                                <td className="text-muted">{client.birth_place}</td>
                                            </tr>
                                            <tr>
                                                <th className="ps-0" scope="row">Indirizzo:</th>
                                                <td className="text-muted">{client.full_address}</td>
                                            </tr>
                                            <tr>
                                                <th className="ps-0" scope="row">Codice Fiscale:</th>
                                                <td className="text-muted">{client.fiscal_code}</td>
                                            </tr>
                                            <tr>
                                                <th className="ps-0" scope="row">Partita IVA:</th>
                                                <td className="text-muted">{client.vat_id}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

export default withRouter(TabAnag);
